import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import styles from './NoPagesAlert.scss';

const propTypes = {
  onClick: PropTypes.func.isRequired,
  navAlert: PropTypes.bool,
};

const navItemMessage = (<div>There are no pages that match your search. Try entering a new search.</div>);

const defaultProps = {};

const NoPagesAlert = ({ onClick, navAlert }) => (
  <Alert context="primary">
    { navAlert ? navItemMessage :
      (
        <div>
          There are no pages that match the filters you've selected. Try&nbsp;
          <button
            type="button"
            onClick={onClick}
            className={styles.button}
          >
          clearing your filters
          </button>
          .
        </div>
      )
    }
  </Alert>
);

NoPagesAlert.propTypes = propTypes;
NoPagesAlert.defaultProps = defaultProps;

export default NoPagesAlert;
